import { matchPath } from "react-router-dom";

// Canonical page identities shared by the editor and contextual reader.
// Specific routes precede parameterized routes; query strings are never identities.
export const guidePaths = [
  { value: "/account/orders/create", label: "ایجاد سفارش" },
  { value: "/account/orders/:id", label: "جزئیات سفارش" },
  { value: "/account/orders", label: "سفارش‌ها" },
  { value: "/account/favorites", label: "کالاهای نشان‌شده" },
  { value: "/account/personnel", label: "مدیریت پرسنل" },
  { value: "/account/profile", label: "اطلاعات حساب" },
  { value: "/products/:productkey", label: "جزئیات کالا" },
  { value: "/products", label: "کاتالوگ کالاها" },
  { value: "/categories/:slug", label: "کالاهای دسته‌بندی" },
  { value: "/categories", label: "دسته‌بندی‌ها" },
  { value: "/search", label: "جست‌وجوی کالا" },
  { value: "/showroom", label: "نمایشگاه" },
  { value: "/login", label: "ورود نمایندگان" },
  { value: "/invitation", label: "ثبت‌نام نمایندگان" },
];

export function getGuidePath(pathname: string): string {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  if (matchPath("/schema/:name", normalized) || matchPath("/:slug/schema/:name", normalized)) return "/products/:productkey";
  if (matchPath("/products/:productkey/:variantTitle", normalized) || matchPath("/products/:productkey/variants/:variantId", normalized)) return "/products/:productkey";
  if (normalized.startsWith("/showroom/")) return "/showroom";
  return guidePaths.find(function (page) {
    return matchPath({ path: page.value, end: true }, normalized) !== null;
  })?.value || normalized.toLowerCase();
}
